import apiService from '../apiService';

const SourcesService = {
  listSources: (params) => apiService.get('/sources', params),
  getSources: (id) => apiService.get(`/sources/${id}`),
  createSources: (data) => apiService.post('/sources', data),
  updateSources: (id, data) => apiService.put(`/sources/${id}`, data),
  deleteSources: (id) => apiService.delete(`/sources/${id}`),
};

export default SourcesService;
